module.exports = __webpack_public_path__ + "static/image/history/pc/201303.ver2_0_2.jpg?ddea4adb";